import { getStylesFn } from 'core/helpers/styles'
import { ElementBulletOptions } from 'core/types/element/element_bullet'
import optionsPropTypes from 'PropsSpec'
import Icon from './common/Icon'

const extractWrapperStyles = getStylesFn(
  [
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'backgroundColor',
    'opacity',
    'borderTop',
    'borderRight',
    'borderBottom',
    'borderLeft',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomRightRadius',
    'borderBottomLeftRadius'
  ],
  {
    display: 'flex',
    flexDirection: 'column'
  }
)

const VARIANT_STYLES = {
  display: 'flex',
  alignItems: 'baseline'
}

const extractLabelStyles = getStylesFn([
  'lineHeight',
  'textTransform',
  'textDecoration',
  'letterSpacing',
  'fontFamily',
  'fontSize',
  'fontWeight'
])

const iconOptions = (icon: ElementBulletOptions['icon']) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: `rgba(${icon.color})`,
  fontSize: icon.size
})

type Props = {
  options: ElementBulletOptions
}

const Bullet = (props: Props) => {
  const { options } = props
  const wrapperStyles = extractWrapperStyles(options)
  const textStyles = {
    ...extractLabelStyles(options.text),
    color: `rgba(${options.text.text_color})`
  }
  const subtextStyles = {
    ...extractLabelStyles(options.subtext),
    color: `rgba(${options.subtext.text_color})`,
    marginLeft: options.subtext.font_size / 2
  }

  const listStyles = {
    display: 'flex',
    flexDirection: 'column'
  }

  const iconWrapperStyles = {
    flexShrink: 0,
    marginRight: options.icon.size / 3
  }

  const orderedLabelStyles = {
    ...textStyles,
    color: `rgba(${options.text.text_color})`,
    width: `${options.text.font_size * 1.3}px`,
    paddingRight: `${options.text.font_size / 2}px`,
    textAlign: 'center'
  }

  const calculateVariantStyles = (i: number) => {
    const result = {
      ...VARIANT_STYLES,
      marginTop: i === 0 ? 0 : options.space,
      justifyContent: { left: 'flex-start', center: 'center', right: 'flex-end' }[options.text_align]
    }

    return result
  }

  return (
    <div className="wf_reset wf_bullet_wrapper" style={wrapperStyles}>
      <div className="wf_reset wf_bullet_list" style={listStyles}>
        {options.list.map(({ text, subtext }, i) => (
          <div key={i} style={calculateVariantStyles(i)} className="wf_reset wf_bullet_list_item">
            {options.type === 'icon' && (
              <div className="wf_reset wf_bullet_icon_wrapper" style={iconWrapperStyles}>
                {options.icon && (
                  <Icon
                    className="wf_reset wf_bullet_icon"
                    code={options.icon.code}
                    styles={iconOptions(options.icon)}
                  />
                )}
              </div>
            )}
            <div className="wf_reset wf_bullet_body" style={{ display: 'inline-block' }}>
              {options.type === 'simple' && <span style={orderedLabelStyles}>{i + 1}.</span>}
              <span className="wf_reset wf_bullet_text" style={textStyles}>
                {text}
              </span>
              <span className="wf_reset wf_bullet_text" style={subtextStyles}>
                {subtext}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
Bullet.propTypes = {
  options: optionsPropTypes('bullet')
}

export default Bullet
